var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-item"},[(_vm.item.type === 'route-details')?_c('div',[_c('router-link',{attrs:{"to":{
                  name: 'routeinfo',
                  params: {
                      id: _vm.item.routeid,
                  },
              }}},[_c('div',[_vm._v(_vm._s(_vm.item.routec)+" "+_vm._s(_vm.item.startc)+" - "+_vm._s(_vm.item.destinc))])])],1):(_vm.item.type === 'route-stop')?_c('div',{staticClass:"history-route-stop"},[_c('FavouriteRoute',{attrs:{"favourite-route":_vm.item}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }